import { DialogActions, Grid, Divider, Typography, Stack, IconButton, Paper } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Button from '../../../components/atoms/Button/Button'
import { Fragment, useState, FC, useEffect } from "react";
import { Cap } from "../../../types/caps";
import moment from "moment";
import Loading from "../../atoms/Loading";
import { useDispatch, useSelector } from "react-redux";
import { CapsHistoryObject } from '../../../store/reducers/CapsHistory';
import { getCapsHistory } from '../../../store/actions/CapsHistory';
import { RootState } from '../../../store/store';
import React from "react";
import { customerTypesArr } from "../../../constants/data_arrays";
type CapsModalProps = {
  cap: Cap;
  closeModal: () => void;
};

const CapsHistory: FC<CapsModalProps> = ({ cap, closeModal }) => {
  const [loading, setLoading] = useState(false);
  const [version, setVersion] = useState(1);
  const dispatch = useDispatch();
  
  const history = useSelector<RootState, CapsHistoryObject>(
    (x) =>
      x.capsHistory.byID[cap.capId] || {
        fetching: false,
        list: [],
        maxHistory: null,
      },
  );

  useEffect(() => {
    if (
      history.list.length <= version - 1 &&
      !history.fetching &&
      (!history.maxHistory || history.maxHistory < version)
    ) {
      dispatch(getCapsHistory(cap.capId, version));
      console.log(`history`, history);
    }
    // eslint-disable-next-line
  }, [version]);
  
  useEffect(() => {
    setLoading(history.fetching);
    console.log(`history`, history);
  }, [history.fetching]);

  console.log(history);

  return (
    <Fragment>  {loading && <Loading />}
        {history.list.length === 0 && 'No History to Show'}
        {history.list.length > 0 && 
          <>
            <Grid width={'100%'} container rowSpacing={1} columnSpacing={{ xs: 1 }} alignContent={'center'}>           
              <Grid item xs={2}  textAlign={'right'}>
                <IconButton
                  disabled={version === 1}
                  onClick={() => setVersion(version - 1)}>
                  <ArrowBackIcon />
                </IconButton> 
              </Grid>
              <Grid item xs={8}  textAlign={'center'}>
                <Typography variant={'subtitle1'}>
                  {history.list[version - 1] ? moment(history.list[version - 1].startedOn).format('MM/DD/YYYY h:mm A') : ''} -{' '}
                  {history.list[version - 1] ? moment(history.list[version - 1].endedOn).format('MM/DD/YYYY h:mm A'): ""}
                </Typography>
                <Typography variant={'h5'}>
                  {history.list[version - 1] ? history.list[version - 1].name : `End of History`}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <IconButton
                  style={{ position: 'relative' }}
                  disabled={
                    (!history.list[version - 1]) ||
                    loading
                  }
                  onClick={() => setVersion(version + 1)}>
                  <ArrowForwardIcon />
                  {loading && <Loading size={32} />}
                </IconButton>
              </Grid>
              {history.list[version - 1] && 
              <>
              <Grid item xs={5} textAlign={'right'}>
                  <Typography variant={'caption'}>
                    {`Customer Types`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  {(() => {
                    const customerTypes = history.list[version - 1].customerTypes;
                    const names = (customerTypes ?? []).map(id => customerTypesArr[id - 1] ?? `Unknown (${id})`);
                    return names.length > 0
                      ? names.map((a, n) => `${a}${n < names.length - 1 ? ',' : ''} `)
                      : 'No Customer Types Assigned';
                  })()}
                </Grid>
                <Grid item xs={5} textAlign={'right'}>
                  <Typography variant={'caption'}>
                    {`Active Start`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  {moment(history.list[version - 1].activeStart).format('MM/DD/YYYY h:mm A')}
                </Grid>
                <Grid item xs={5} textAlign={'right'}>
                  <Typography variant={'caption'}>
                    {`Active End`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  {moment(history.list[version - 1].activeEnd).format('MM/DD/YYYY h:mm A')}
                </Grid>
                <Grid item xs={5} textAlign={'right'}>
                  <Typography variant={'caption'}>
                    {`Amount`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  {history.list[version - 1].amount}
                </Grid>
                <Grid item xs={5} textAlign={'right'}>
                  <Typography variant={'caption'}>
                    {`Periods`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  {history.list[version - 1].period}
                </Grid>
                <Grid item xs={5} textAlign={'right'}>
                  <Typography variant={'caption'}>
                    {`Origins`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  {history.list[version - 1].origins.length > 0 
                    ? history.list[version - 1].origins.map((a, n) => {return `${a}${n < (history.list[version - 1].origins.length - 1) ? ',' : ''} `})
                    : 'No Origins Assigned'
                  }
                </Grid>
                <Grid item xs={5} textAlign={'right'}>
                  <Typography variant={'caption'}>
                    {`States`}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  {history.list[version - 1].states.length > 0 
                    ? history.list[version - 1].states.map((a, n) => {return `${a}${n < (history.list[version - 1].states.length - 1) ? ',' : ''} `})
                    : 'No States Assigned'
                  }
                </Grid>
                
              </>}
            </Grid>
          </>
        }
        <DialogActions>
            <Button
                fullWidth
                id={`caps-modal-${cap ? "edit" : "create"}-button`}
                name="submit"
                type={'submit'}
                variant="contained"
                color="primary"
                onClick={() => closeModal()}
            >
                Close
            </Button>
        </DialogActions>
    </Fragment>
  );
};
export default CapsHistory;
